import React from 'react'
import { ChevronLeftIcon } from '@heroicons/react/24/outline'
import { useNavigate } from 'react-router-dom'

export default function PageHeaderV2({ titlename, description, btnBackWard, backpath, type = undefined, type_v2 = undefined, option = undefined }) {
    const nevigate = useNavigate()

    const toNavigateComponent = (url) => {
        if (type) {
            nevigate(url, { state: { type: type } })
        } else if (option) {
            nevigate(url, { state: { option: option, type: type_v2 } })
        } else {
            nevigate(url, { state: { type: type } })
        }
    }

    return (
        <>
            {
                btnBackWard ?
                    <button className='flex items-center mt-16 ml-20 sm:ml-5' onClick={() => { toNavigateComponent(backpath) }}>
                        <ChevronLeftIcon className='md:w-5 w-10 stroke-[#A2B5BC;]' />
                        <div className='md:text-[14px] text-[#000000] '>ย้อนกลับ</div>
                    </button> : null
            }
            {
                titlename ?
                    <div className={`text-3xl md:text-[18px] text-[#747081] flex justify-start font-bold ${btnBackWard ? '' : 'mt-[44px]'} md:mb-2 mb-4`} style={{font:"normal normal 600 28px / 42px Prompt"}}>
                        {titlename}
                    </div> : null
            }
            {
                description ?
                    <div className='text-xl sm:text-sm text-[#000000] flex justify-center mt-2 font-bold'>
                        {description}
                    </div> : null
            }
        </>
    )
}
